import React from 'react'
import Button from './Button'

const PlainButton = props => (
  <Button {...props} plain inline></Button>
)

export default PlainButton